<template>
  <div class="happySpaceDetail">
    <div class="happySpaceDetail_top">
      <img
        src="@/assets/images/grow-club/back.png"
        class="happySpaceDetail_top_goback"
        @click="goback"
      />
      <img
        src="@/assets/images/grow-club/emotion-people.png"
        class="happySpaceDetail_top_right"
      />
      <div class="happySpaceDetail_top_center">
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="happySpaceDetail_box" v-if="!nodataFlag">
      <van-list
        ref="listContent"
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="loadMore"
      >
        <div
          class="happySpaceDetail_box_list"
          v-for="(item, index) in courseList"
          :key="index"
          @click="goVideo(item)"
        >
          <img
            :src="item.coverMaterialUrl | addHost"
            class="happySpaceDetail_box_list_pic"
            alt="hi"
          />
          <!-- <div class="img_1" v-if="!item.coverMaterialUrl">
                           <div class="img_1_1">
                                <img src="../../assets/images/parent-course/video-blank.png" class="happySpaceDetail_box_list_pic" alt='hi'/>
                           </div>
                        </div> -->
          <p class="happySpaceDetail_box_list_title">{{ item.title }}</p>
          <div class="happySpaceDetail_box_list_title_list" v-if="item.tags">
            <div
              :class="[
                index1 == 0 ? 'active1' : index1 == 1 ? 'active2' : 'active3',
                'happySpaceDetail_box_list_tag',
              ]"
              v-for="(item1, index1) in item.tags.split(',').slice(0, 3)"
              :key="index1"
            >
              {{ item1 }}
            </div>
          </div>
          <div class="happySpaceDetail_box_dec">
            <div class="happySpaceDetail_box_dec_circle"></div>
            <div class="happySpaceDetail_box_dec_title">{{ item.author }}</div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="nodata_part" v-if="nodataFlag">
      <happy-no />
    </div>
  </div>
</template>
<script>
import { _getColumnContents } from "../../api/parent-course";
import { horizontalScreen } from "../../assets/js/horizontal";
import happyNo from "../../components/parent-course/happy-no.vue";
export default {
  components: { happyNo },
  name: "happy-space-detail",
  data() {
    return {
      nodataFlag: false,
      courseList: [],
      finished: false, //加载状态
      loading: false,
      infoObj: {}, //上一页存储的信息
      title: "",
      contentParams: {
        asc: false,
        currentPage: 0,
        // orderByField: "createTime",
        pageSize: 5,
        queryData: {
          columnId: this.$storage.getStore("happyInfoTab").id,
          contentType: "VIDEO",
          putaway: true,
          tag: "儿童",
        },
      },
    };
  },
  filters: {
    addHost: function (val) {
      let host = location.host;
      // return 'http://' + host + '/' + val
      //  return 'http://172.16.12.104:8999/' + val
      return val;
    },
  },
  created() {
    this.title = this.$route.query.title;
    //获取信息obj对象
    this.infoObj = this.$storage.getStore("happyInfoTab");
  },
  mounted() {
    horizontalScreen(); //横屏
  },
  methods: {
    //点击返回按钮
    goback() {
      this.$router.go(-1);
    },
    goVideo(item) {
      this.$bus.$emit("fullFn", true);
      this.$storage.setStore("happySpaceVideo", item);
      this.$router.push({
        path: "/happySpaceVideo",
        query: {
          title: item.name,
          from: 1,
        },
      });
    },
    loadMore() {
      let { contentParams } = this;
      contentParams.currentPage += 1;
      this.getColumnContents(contentParams);
    },
    // 根据id获取栏目下的内容
    async getColumnContents(contentParams) {
      try {
        let res = await _getColumnContents(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.courseList = this.courseList.concat(data.records);
          if (this.courseList.length === 0) {
            this.nodataFlag = true;
          } else {
            this.nodataFlag = false;
          }
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
        } else {
          this.courseList = [];
          this.loading = false;
          this.nodataFlag = true;
          // this.error = true
          Toast(message);
        }
      } catch (error) {
        this.nodataFlag = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.happySpaceDetail {
  width: 100%;
  height: 100%;
  background: url(./../../assets/images/grow-club/detail-bg.png);
  background-size: cover;
  .happySpaceDetail_top {
    display: flex;
    justify-content: space-between;
    position: relative;
    .happySpaceDetail_top_goback {
      width: 29px;
      height: 29px;
      margin: 15px 0 0 15px;
      z-index: 9999999;
    }
    .happySpaceDetail_top_right {
      width: 123px;
      height: 53px;
      margin: 10px 20px 0 0;
    }
    .happySpaceDetail_top_center {
      margin: auto;
      position: absolute;
      display: inline-block;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      text-align: center;
      span {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        text-align: center;
        padding: 10px 30px;
        background: url(./../../assets/images/grow-club/text-box.png);
        background-size: 100% 100%;
      }
    }
  }
  .happySpaceDetail_box {
    margin-top: 18px;
    display: flex;
    width: 100%;
    overflow-x: scroll;
    padding-left: 16px;
    .van-list {
      display: flex;
    }
    .happySpaceDetail_box_list {
      width: 208px;
      height: 212px;
      background: url(./../../assets/images/grow-club/meng.png);
      background-size: 100% 100%;
      margin-left: 20px;
      .img_1 {
        // width: 208px;
        // height: 212px;
        background-color: #f8f7fa;
        // border: 1px solid red;
        .img_1_1 {
          // width: 60px;
          // height: 45px;
          // border: 1px solid red;
          img {
            width: 60px;
            height: 45px;
          }
        }
      }
      .happySpaceDetail_box_list_pic {
        width: 178px;
        height: 101px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
      }
      .happySpaceDetail_box_list_title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        // text-align: center;
        padding-left: 16px;
        margin-top: 10px;
      }
      .happySpaceDetail_box_list_title_list {
        display: flex;
        // justify-content: space-between;
        flex: 1;
        margin: 10px 15px;
        .happySpaceDetail_box_list_tag {
          margin-right: 5px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 17px;
          padding: 0 10px;
          border-radius: 11px;
          height: 22px;
          line-height: 22px;
        }
        .active1 {
          background: rgba(255, 148, 134, 0.31);
          color: #f56444;
        }
        .active2 {
          background: rgba(255, 243, 235, 0.22);
          color: #ff8340;
        }
        .active3 {
          background: rgba(73, 204, 154, 0.1);
          color: #49cc9a;
        }
      }
      .happySpaceDetail_box_dec {
        display: flex;
        .happySpaceDetail_box_dec_circle {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ffaa00;
          margin-left: 15px;
          margin-top: 6px;
        }
        .happySpaceDetail_box_dec_title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-left: 5px;
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}
</style>
